// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input.form-check-input:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/toggle-input/toggle-input.component.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;EACA,YAAA;AACJ","sourcesContent":["input.form-check-input:disabled {\n    cursor: not-allowed;\n    opacity: 0.6;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
